export function selectTable(id: number): BaseTockAction {
  return {
    type: 'SELECT_TABLE',
    payload: id,
  };
}

export function deselectTable(id: number): BaseTockAction {
  return {
    type: 'DESELECT_TABLE',
    payload: id,
  };
}

export function replaceTable(id: number): BaseTockAction {
  return {
    type: 'REPLACE_TABLE',
    payload: id,
  };
}

export function deselectTables(): BaseTockAction {
  return {
    type: 'DESELECT_TABLES',
  };
}
